<template>
  <div
    v-if="showDefaultMessage"
    class="default-message mt-1 mb-3"
  >
    <div class="default-message__label mb-1">{{ $t("dashboard-settings.mypage-default-message") }}</div>
    <div class="default-message__body mt-1">
      <template v-if="settingKey === 'A'">
        <span>{{ $t("mypage.optional-text-1-1") }}</span><span>{{ $t("mypage.optional-text-1-2") }}</span><span>{{ $t("mypage.optional-text-1-3") }}</span>
      </template>
      <template v-else-if="settingKey === 'B'">
        <span>{{ $t("mypage.optional-text-2-1") }}</span><span>{{ $t("mypage.optional-text-2-2") }}</span>
      </template>
      <template v-else-if="settingKey === 'C'">
        <span>{{ $t("mypage.optional-text-3-1") }}</span>
      </template>
    </div>
    <div class="default-message__guide mt-2">
      <div>
        <span class="default-message__guide-strong">{{ $t("dashboard-settings.mypage-custom-message-guide-strong") }}</span><span class="default-message__guide-inline">{{ $t("dashboard-settings.mypage-custom-message-guide-note-main") }}</span>
      </div>
      <div class="default-message__guide-note mt-1">
        {{ $t("dashboard-settings.mypage-custom-message-guide-note-sub") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settingKey: {
      type: String,
      required: true
    }
  },
  computed: {
    showDefaultMessage() {
      return ["ja", "en"].includes(this.$i18n.locale);
    }
  }
};
</script>

<style lang="scss" scoped>
.default-message__body {
  font-size: 0.78rem;
  white-space: pre-wrap;
}

.default-message__guide {
  font-size: 0.72rem;
  white-space: pre-wrap;
}

.default-message__guide-inline {
  font-size: 0.72rem;
  margin-left: 0.2rem;
}

.default-message__guide-strong {
  font-size: 0.72rem;
  font-weight: 700;
}

.default-message__guide-note {
  font-size: 0.72rem;
}

.default-message__label,
.default-message .font-weight-bold {
  font-size: 0.78rem;
}
</style>
